const generateEndpoint = () => {
  /* eslint-disable no-fallthrough */
  switch (process.env.VUE_APP_DEVELOPMENT_MODE?.toLowerCase()) {
    case "local":
      return "http://localhost:5125"
    case "development":
    case "staging":
      return "https://api.staging.telarya.be"
  }
  return "https://api.telarya.be:5125"
}

export default generateEndpoint
